export default __webpack_public_path__ + "static/media/paypal4.763b1489.png";